import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, Alert, Button, CircularProgress } from '@mui/material';
import { Link, useSearchParams } from 'react-router-dom';
import apiClient from '../api/client';

export default function VerifyEmailPage({ onLogin }) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setError('Invalid verification link.'); return; }
    apiClient.post('/auth/verify-email', { token })
      .then(({ data }) => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        onLogin(data.user);
        setStatus('success');
      })
      .catch(err => {
        setStatus('error');
        setError(err.response?.data?.error || 'Verification failed');
      });
  }, [token]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5' }}>
      <Card sx={{ width: 400 }}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          {status === 'verifying' && (
            <>
              <CircularProgress sx={{ mb: 2 }} />
              <Typography>Verifying your email…</Typography>
            </>
          )}
          {status === 'success' && (
            <>
              <Typography variant="h5" fontWeight={700} mb={2}>Email verified!</Typography>
              <Alert severity="success" sx={{ mb: 3 }}>Your account is active. Taking you to the app…</Alert>
              <Button component={Link} to="/" variant="contained">Go to app</Button>
            </>
          )}
          {status === 'error' && (
            <>
              <Typography variant="h5" fontWeight={700} mb={2}>Verification failed</Typography>
              <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>
              <Button component={Link} to="/login" variant="outlined" sx={{ mr: 1 }}>Sign in</Button>
              <Button component={Link} to="/resend-verification" variant="contained">Request new link</Button>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
